// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-circle{align-items:center;background:linear-gradient(90deg,#efa824,#ed9325);border-radius:50%;box-shadow:0 1px 6px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.12);color:#fff;cursor:pointer;display:flex;font-size:20px;height:30px;justify-content:center;width:30px}.btn-circle:hover{opacity:.8}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
